import { Button } from '../components/Button';
import { EnemyInfo } from '../components/EnemyInfo';
import { View } from '../components/View';
import { enemies } from '../configs/enemies';
import { useGameStore } from '../hooks/useGameStore';

export function EnemyView() {
  const next = useGameStore((state) => state.nextView);

  return (
    <View title="Fånga oss i spelet">
      <div className="flex flex-row space-x-14 mt-8 mb-10 xl:mb-14">
        {enemies.map((enemy) => (
          <EnemyInfo
            key={enemy.type}
            type={enemy.type}
            name={enemy.name}
            description={enemy.description}
            points={enemy.points}
            icon={enemy.icon}
          />
        ))}
      </div>

      <Button onClick={() => next()}>Välj spelare!</Button>
    </View>
  );
}
